/**
 * Polyfill for the `onbeforescriptexecute` event.
 */
if (!("onbeforescriptexecute" in window) && !("onbeforescriptexecute" in document)) {
  const scriptWatcher = new MutationObserver((mutations: MutationRecord[]) => {
    for (const mutation of mutations) {
      for (let i = 0; i < mutation.addedNodes.length; i++) {
        const node = mutation.addedNodes[i];
        if (node instanceof HTMLScriptElement) {
          const syntheticEvent = new CustomEvent<Node>("beforescriptexecute", {
            detail: node,
            cancelable: true,
            bubbles: true,
          });
          if (!document.dispatchEvent(syntheticEvent)) {
            node.remove();
          }
        }
      }
    }
  });

  scriptWatcher.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}
